import React, { useContext } from "react";
import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Box,
  Toolbar,
  useTheme,
} from "@mui/material";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import LogoutIcon from "@mui/icons-material/Logout";
import { href, Link, useLocation, useNavigate } from "react-router-dom";
import { AuthContext } from "../theme/AuthContext";

export const SIDEBAR_WIDTH = 250;

const menu = [
  {
    text: "Dashboard",
    icon: <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.25 2.25H8.25V9.75H2.25V2.25ZM3.75 3.75V8.25H6.75V3.75H3.75ZM9.75 2.25H15.75V6.75H9.75V2.25ZM11.25 3.75V5.25H14.25V3.75H11.25ZM9.75 8.25H15.75V15.75H9.75V8.25ZM11.25 9.75V14.25H14.25V9.75H11.25ZM2.25 11.25H8.25V15.75H2.25V11.25ZM3.75 12.75V14.25H6.75V12.75H3.75Z" fill="currentcolor" />
    </svg>
    , href: "/"
  },
  {
    text: "My Courses",
    icon: <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.5625 12.3273L8.625 14.5421L4.6875 12.3273V9.98722L3.5625 9.36221V12.9852L8.625 15.8329L13.6875 12.9852V9.36221L12.5625 9.98722V12.3273Z" fill="#6E6D81" />
      <path d="M8.625 1.61639L0.75 5.69972V6.67475L8.625 11.0496L15.375 7.29975V10.4063H16.5V5.69972L8.625 1.61639ZM14.25 6.6378L13.125 7.26277L8.625 9.76291L4.125 7.26277L3 6.6378L2.22027 6.2046L8.625 2.88364L15.0297 6.2046L14.25 6.6378Z" fill="currentcolor" />
    </svg>
    ,
    href: "/courses"
  },
  // {
  //   text: "Build Your Resume",
  //   icon: <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
  //     <path d="M2.25 10.5V7.5C2.25 4.67175 2.25 3.25725 3.129 2.379C4.008 1.50075 5.42175 1.5 8.25 1.5H9.75C12.5782 1.5 13.9927 1.5 14.871 2.379C15.3615 2.86875 15.5783 3.525 15.6735 4.5M15.75 7.5V10.5C15.75 13.3282 15.75 14.7427 14.871 15.621C13.992 16.4992 12.5782 16.5 9.75 16.5H8.25C5.42175 16.5 4.00725 16.5 3.129 15.621C2.6385 15.1312 2.42175 14.475 2.3265 13.5M6 10.5H9.75M6 7.5H6.75M12 7.5H9" stroke="currentcolor" stroke-width="1.125" stroke-linecap="round" fill="currentcolor" />
  //   </svg>
  //   ,
  //   href: "/buildresume"
  // },

  // {
  //   text: "Coding Lab",
  //   icon: <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
  //     <g clip-path="url(#clip0_61_5010)">
  //       <path d="M10.8645 2.35723C11.0559 2.41108 11.2181 2.53874 11.3155 2.71215C11.4128 2.88556 11.4373 3.09053 11.3835 3.28198L8.061 15.123C8.03441 15.2178 7.98939 15.3065 7.92853 15.384C7.86766 15.4614 7.79214 15.5261 7.70627 15.5744C7.6204 15.6226 7.52586 15.6535 7.42806 15.6652C7.33025 15.677 7.2311 15.6693 7.13625 15.6427C7.0414 15.6161 6.95272 15.5711 6.87527 15.5103C6.79782 15.4494 6.73312 15.3739 6.68485 15.288C6.63659 15.2021 6.60571 15.1076 6.59398 15.0098C6.58226 14.912 6.58991 14.8128 6.6165 14.718L9.939 2.87698C9.96558 2.78205 10.0106 2.69328 10.0715 2.61576C10.1324 2.53825 10.208 2.4735 10.294 2.42523C10.3799 2.37695 10.4746 2.3461 10.5725 2.33443C10.6704 2.32277 10.7696 2.33051 10.8645 2.35723ZM5.40525 5.28748C5.54585 5.42813 5.62484 5.61886 5.62484 5.81773C5.62484 6.01661 5.54585 6.20734 5.40525 6.34798L2.754 8.99998L5.40525 11.6512C5.47493 11.7209 5.53022 11.8035 5.56795 11.8945C5.60568 11.9855 5.62512 12.0831 5.62515 12.1816C5.62519 12.2801 5.60582 12.3777 5.56815 12.4687C5.53048 12.5597 5.47526 12.6424 5.40562 12.7121C5.33599 12.7818 5.25331 12.8371 5.16231 12.8748C5.07132 12.9125 4.97378 12.932 4.87526 12.932C4.77675 12.932 4.6792 12.9127 4.58817 12.875C4.49715 12.8373 4.41443 12.7821 4.34475 12.7125L1.1625 9.53023C1.0219 9.38959 0.942909 9.19886 0.942909 8.99998C0.942909 8.80111 1.0219 8.61038 1.1625 8.46973L4.34475 5.28748C4.48539 5.14688 4.67613 5.06789 4.875 5.06789C5.07387 5.06789 5.2646 5.14688 5.40525 5.28748ZM12.5947 6.34798C12.5231 6.2788 12.466 6.19604 12.4267 6.10454C12.3874 6.01303 12.3667 5.91462 12.3658 5.81503C12.3649 5.71545 12.3839 5.61669 12.4216 5.52452C12.4593 5.43234 12.515 5.34861 12.5855 5.27819C12.6559 5.20777 12.7396 5.15208 12.8318 5.11437C12.924 5.07666 13.0227 5.05768 13.1223 5.05854C13.2219 5.05941 13.3203 5.0801 13.4118 5.11941C13.5033 5.15871 13.5861 5.21585 13.6552 5.28748L16.8375 8.46973C16.9781 8.61038 17.0571 8.80111 17.0571 8.99998C17.0571 9.19886 16.9781 9.38959 16.8375 9.53023L13.6552 12.7125C13.5145 12.8531 13.3237 12.9321 13.1247 12.932C12.9258 12.9319 12.735 12.8528 12.5944 12.7121C12.4537 12.5714 12.3748 12.3805 12.3748 12.1816C12.3749 11.9826 12.454 11.7919 12.5947 11.6512L15.246 8.99998L12.5947 6.34798Z" fill="currentcolor" />
  //     </g>
  //     <defs>
  //       <clipPath id="clip0_61_5010">
  //         <rect width="18" height="18" fill="white" />
  //       </clipPath>
  //     </defs>
  //   </svg>
  //   ,
  //   href: "/practice-lab"
  // },
  {
    text: "Quizzer",
    icon: <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.2802 2.46975C10.1396 2.32909 9.9489 2.25004 9.75 2.25H3C2.80109 2.25 2.61032 2.32902 2.46967 2.46967C2.32902 2.61032 2.25 2.80109 2.25 3V9.75C2.25 9.9495 2.32875 10.14 2.46975 10.2802L8.46975 16.2803C8.53924 16.3501 8.62186 16.4056 8.71286 16.4434C8.80386 16.4813 8.90144 16.5008 9 16.5008C9.09856 16.5008 9.19614 16.4813 9.28714 16.4434C9.37814 16.4056 9.46076 16.3501 9.53025 16.2803L16.2803 9.53025C16.4209 9.3896 16.4998 9.19887 16.4998 9C16.4998 8.80113 16.4209 8.6104 16.2803 8.46975L10.2802 2.46975ZM9 14.6895L3.75 9.4395V3.75H9.4395L14.6895 9L9 14.6895Z" fill="currentcolor" />
      <path d="M6.372 7.49999C6.99539 7.49999 7.50075 6.99463 7.50075 6.37124C7.50075 5.74785 6.99539 5.24249 6.372 5.24249C5.74861 5.24249 5.24325 5.74785 5.24325 6.37124C5.24325 6.99463 5.74861 7.49999 6.372 7.49999Z" fill="currentcolor" />
    </svg>,
    href: "/quizzer"
  },
  //  {
  //   text: "Live Classes",
  //   icon: <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
  //     <path d="M10.2802 2.46975C10.1396 2.32909 9.9489 2.25004 9.75 2.25H3C2.80109 2.25 2.61032 2.32902 2.46967 2.46967C2.32902 2.61032 2.25 2.80109 2.25 3V9.75C2.25 9.9495 2.32875 10.14 2.46975 10.2802L8.46975 16.2803C8.53924 16.3501 8.62186 16.4056 8.71286 16.4434C8.80386 16.4813 8.90144 16.5008 9 16.5008C9.09856 16.5008 9.19614 16.4813 9.28714 16.4434C9.37814 16.4056 9.46076 16.3501 9.53025 16.2803L16.2803 9.53025C16.4209 9.3896 16.4998 9.19887 16.4998 9C16.4998 8.80113 16.4209 8.6104 16.2803 8.46975L10.2802 2.46975ZM9 14.6895L3.75 9.4395V3.75H9.4395L14.6895 9L9 14.6895Z" fill="currentcolor" />
  //     <path d="M6.372 7.49999C6.99539 7.49999 7.50075 6.99463 7.50075 6.37124C7.50075 5.74785 6.99539 5.24249 6.372 5.24249C5.74861 5.24249 5.24325 5.74785 5.24325 6.37124C5.24325 6.99463 5.74861 7.49999 6.372 7.49999Z" fill="currentcolor" />
  //   </svg>,
  //   href: "/liveclasses"
  // },
  // {
  //   text: "Certificate",
  //   icon: <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
  //     <path d="M8.625 16.5C5.61975 16.5 4.1175 16.5 3.18375 15.4012C2.25 14.304 2.25 12.5355 2.25 9C2.25 5.4645 2.25 3.69675 3.18375 2.598C4.1175 1.49925 5.61975 1.5 8.625 1.5C11.6302 1.5 13.1325 1.5 14.0662 2.598C14.8177 3.483 14.9647 4.80075 14.9932 7.125M6 6H11.25M6 9.75H8.25" stroke="#6E6D81" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round" />
  //     <path d="M14.7075 13.5787C15.1399 13.2645 15.4617 12.8214 15.6268 12.3129C15.7918 11.8045 15.7917 11.2569 15.6264 10.7486C15.4611 10.2402 15.1392 9.79725 14.7067 9.48314C14.2741 9.16903 13.7533 8.9999 13.2188 9H13.0305C12.496 9.00006 11.9753 9.1693 11.5429 9.48347C11.1105 9.79764 10.7887 10.2406 10.6235 10.7489C10.4583 11.2572 10.4582 11.8048 10.6233 12.3131C10.7884 12.8215 11.1102 13.2645 11.5425 13.5787M11.5425 13.5787C11.9746 13.8938 12.4957 14.0632 13.0305 14.0625H13.218C13.7528 14.0632 14.2739 13.8938 14.706 13.5787L15.1433 14.955C15.3098 15.48 15.3938 15.7425 15.3705 15.906C15.3233 16.2465 15.0458 16.4985 14.718 16.5C14.5605 16.5 14.325 16.377 13.8533 16.1295C13.6508 16.023 13.5503 15.9705 13.4468 15.939C13.2364 15.876 13.0121 15.876 12.8018 15.939C12.6983 15.9705 12.597 16.023 12.3953 16.1295C11.9235 16.377 11.688 16.5008 11.5305 16.5C11.2028 16.4985 10.9253 16.2465 10.878 15.906C10.8555 15.7425 10.938 15.48 11.1053 14.955L11.5425 13.5787Z" stroke="#6E6D81" stroke-width="1.125" />
  //   </svg>,
  //   href: "/certificates"
  // },
  // { text: "Settings", icon: <WorkspacePremiumIcon />, href: "/settings" },
  { text: "Logout", icon: <LogoutIcon /> },
];

export default function Sidebar({ open, onClose }) {
  const theme = useTheme();
  const location = useLocation();
  const navigate = useNavigate();
  const { logout } = useContext(AuthContext)

  const handleLogout = () => {
    logout()
  };

  const content = (
    <Box sx={{ width: { md: 230, lg: SIDEBAR_WIDTH }, marginTop: "20px" }}>
      <Toolbar />
      <List>
        {menu.map((m) => {
          const isActive = location.pathname === m.href;
          return (
            <ListItem key={m.text} disablePadding>
              <ListItemButton
                component={m.href ? Link : "button"}
                to={m.href || undefined}
                onClick={
                  m.text === "Logout"
                    ? handleLogout
                    : onClose
                }
                sx={{
                  position: "relative",
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    left: 0,
                    top: 0,
                    height: "100%",
                    width: isActive ? "4px" : "0px",
                    backgroundColor: theme.palette.primary.main,
                    borderRadius: "0 4px 4px 0",
                    transition: "0.3s",
                  },
                  pl: 3
                }}
              >
                <ListItemIcon sx={{ color: isActive ? theme.palette.primary.main : theme.palette.text.secondary }}>{m.icon}</ListItemIcon>
                <ListItemText sx={{ color: isActive ? theme.palette.primary.main : theme.palette.text.secondary }} primary={m.text} />
              </ListItemButton>
            </ListItem>
          )
        })}
      </List>
    </Box>
  );

  return (
    <>
      {/* Mobile drawer */}
      <Drawer
        variant="temporary"
        open={open}
        onClose={onClose}
        ModalProps={{ keepMounted: true }}
        sx={{
          display: { xs: "block", md: "none" },
          "& .MuiDrawer-paper": { width: SIDEBAR_WIDTH },
          overflowX: "hidden"
        }}
      >
        {content}
      </Drawer>

      {/* Desktop drawer */}
      <Drawer
        variant="permanent"
        open
        sx={{
          display: { xs: "none", md: "block" },
          "& .MuiDrawer-paper": { width: SIDEBAR_WIDTH, top: 0 },
          overflowX: "hidden"
        }}
      >
        {content}
      </Drawer>
    </>
  );
}
